import { render, staticRenderFns } from "./CustomerSelectionItem.vue?vue&type=template&id=fb40fe90"
import script from "./CustomerSelectionItem.vue?vue&type=script&lang=js"
export * from "./CustomerSelectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports